import Vue from 'vue'
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify';
import Vuex from 'vuex'
import Axios from 'axios'
const jwt = require('jsonwebtoken');


let env = 'development'
env = 'production'
//env = 'test'

Vue.prototype.$http = Axios
Vue.prototype.$remote = "https://api.mpev.au"
Vue.prototype.$express = "https://api.mpev.au"

if (env === 'development') {
    Vue.prototype.$remote = "http://127.0.0.1:3000"
    Vue.prototype.$express = "http://127.0.0.1:3000"
}

Vue.prototype.$isTokenCurrent = function() {
    let token = localStorage.getItem('token')
    if (token==null) return false
    const jwtObj = jwt.decode(token,null)
    return (jwtObj.exp * 1000) > new Date().valueOf()
}

Vue.prototype.$hasRole = function (roles) {
    let token = localStorage.getItem('token')
    if (token==null) return false
    if (Vue.prototype.$usrStore.id==null){
        Vue.prototype.$initFromToken(token)
    }
    for (const r of roles) {
        if (Vue.prototype.$usrStore.roles.indexOf(r) > -1) {
            return true
        }
    }
    return false
}

Vue.prototype.$iso2AU = function (dt) {
    if (dt) {
        let yy = dt.slice(0, 4)
        let mm = dt.slice(5, 7)
        let dd = dt.slice(8, 10)
        return dd + '.' + mm + '.' + yy
    } else {
        return null
    }
}

Vue.prototype.$daySpan = function (dt1, dt2) {
    if (dt1 && dt2) {
        const timeDiff = (dt1.getTime() - dt2.getTime())
        const days = (timeDiff / (1000 * 60 * 60 * 24))
        return days
    } else {
        return null
    }
}

Vue.prototype.$AU2Iso = function (dt) {
    if (dt) {
        let dd = dt.slice(0, 2)
        let mm = dt.slice(3, 5)
        let yy = dt.slice(6, 10)
        return yy + '-' + mm + '-' + dd
    } else {
        return null
    }
}

Vue.prototype.$UUIDv4 = function () {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
    });

}

Vue.prototype.$usrStore = {
    id: null,
    name: null,
    mNbr: null,
    token: null,
    email: null,
    roles: [],
    toRenew: {},
    memberSince: null,
}

Vue.prototype.$initFromToken = function (token) {
    const uobj = JSON.parse(atob(token.split('.')[1]))
    this.$usrStore.token = token
    this.$usrStore.id = uobj.r.id
    this.$usrStore.mNbr = uobj.r.mNbr
    this.$usrStore.name = uobj.r.name
    this.$usrStore.email = uobj.r.email
    this.$usrStore.roles = uobj.r.roles
    this.$usrStore.titles = uobj.r.titles
    //this.$store.commit('setLoggedIn', true)
    localStorage.setItem('token', token)
    localStorage.setItem('usrStore',btoa(JSON.stringify(Vue.prototype.$usrStore)))
}


Vue.prototype.$itmStore = {
    roles: [],
    categories: [],
    titles: null,
    trialTypes: [],
    titleList: [],
    states: ['ACT', 'NSW', 'NT', 'QLD', 'SA', 'TAS', 'VIC', 'WA']
}

Vue.prototype.$logOut = function () {
    Vue.prototype.$usrStore.id = null
    Vue.prototype.$usrStore.name = null
    Vue.prototype.$usrStore.mNbr = null
    Vue.prototype.$usrStore.token = null
    Vue.prototype.$usrStore.email = null
    Vue.prototype.$usrStore.roles = []
    localStorage.removeItem('token')
    localStorage.removeItem('usrStore')
}

Vue.prototype.$centiSec2txt = function (cents) {
    let mins = Math.floor(cents / 6000)
    let secs = (cents - mins*6000) / 100
    return `${mins}:${secs.toFixed(2)}`
}

/*
import LoadScript from 'vue-plugin-load-script'
//Vue.prototype.$loadScript = LoadScript
Vue.use(LoadScript);
*/
// Test of loading in global code
Vue.mixin({
    methods: {
        globalHelper: function () {
            alert("Hello world")
        },
        gLoadRoles: function () {
            let theToken = localStorage.getItem('token')
            if (theToken == null) {
                // alert('You must log in to access this feature')
                this.$router.push('/')
            }

            Vue.prototype.$http.post(this.$remote + '/api/roles', {
                token: theToken
            })
                .then(response => {
                    Vue.prototype.$itmStore.roles = response.data.roles
                    Vue.prototype.$usrStore.token = response.data.token
                    localStorage.setItem('token', response.data.token)
                })
                .catch(function (err) {
                        if (err.response.data) {
                            alert(err.response.data.msg)
                        } else {
                            alert(err)
                        }
                    }
                )
        }
    },
})
Vue.prototype.$loadTitles = function () {
    let theToken = localStorage.getItem('token')
    if (theToken == null) {
        // alert('You must log in to access this feature')
        this.$router.push('/')
    }
    this.error = this.jsdoc = null
    this.loading = true

    this.$http.post(this.$remote + '/api/titles', {
        token: theToken
    })
        .then(response => {
            this.$itmStore.titles = {}
            for (let i=0; i< response.data.titles.length; i++) {
                let title = response.data.titles[i]
                let code = title.titleCode
                this.$itmStore.titles[code] = title
            }
            this.$itmStore.titleList = response.data.titles
            this.$usrStore.token = response.data.token
            localStorage.setItem('token', response.data.token)
            this.loading = false
        })
        .catch(function (err) {
                if (err.response.data) {
                    alert(err.response.data.msg)
                } else {
                    alert(err)
                }
            }
        )
}

Vue.use(Vuex)

const store = new Vuex.Store({
    state: {
        loggedIn: false,
        roles: [],
        loginMsg: '',
        sessobj: null
    },
    mutations: {
        setLogin(state, login) {
            state.loggedIn = false
            const l1 = login.user.toLowerCase()
            const p1 = login.pwd.toLowerCase()
            if (l1) {
                if (l1 in state.logins) {
                    if (state.logins[l1] == p1) {
                        state.loginMsg = ''
                        state.loggedIn = true
                        localStorage.setItem('loggedIn', login.user)
                        // console.log(localStorage.getItem('loggedIn'))
                    } else {
                        state.loginMsg = 'Sorry, that was not the correct password'
                    }
                } else {
                    state.loginMsg = 'No such user found'
                }
            }
        },
        setLoggedIn(state, loginState) {
            state.loggedIn = loginState
        }
    },
    getters: {
        isLoggedIn: (state) => state.loggedIn,
        loginMsg: (state) => state.loginMsg
    }
})


Vue.config.productionTip = false

new Vue({
    router,
    vuetify,
    store,
    render: h => h(App)
}).$mount('#app')
